import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const customerConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default customerConfig;
